import { render, staticRenderFns } from "./ProductPriceDetail.vue?vue&type=template&id=7b4509da&lang=pug&"
import script from "./ProductPriceDetail.vue?vue&type=script&lang=js&"
export * from "./ProductPriceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductPriceDetail.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDivider,
  VFlex,
  VLayout,
  VList,
  VListTile,
  VToolbar,
})
